import React, { useState, useEffect, use } from "react";
import {
  Drawer,
  Form,
  Select,
  Button,
  AutoComplete,
  Col,
  Row,
  Input,
  InputNumber,
} from "antd";

import useFetchCommonTypes from "./Hooks/useCommonTypes";

function AddMaterialDrawer({
  onDrawerClose,
  isDrawerOpen,
  title,
  finishSubmit,
  isloading,
  initialValues,
}) {
  const [addEditStockItemForm] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const {
    taxTypes,
    getMaterialSelected,
    measurementTypes,
    materialTypes,
    error: dataLoadingError,
    isLoading: commonDataIsLoading,
  } = useFetchCommonTypes();

  useEffect(() => {
    onFill(initialValues);
  }, [initialValues, isDrawerOpen]);

  const handleValuesChange = (changedValues, allValues) => {
    const taxValues = allValues.stockReceiptLineTaxes || {};
    const total = Object.values(taxValues).reduce(
      (sum, item) => sum + (Number(item.taxAmount) || 0),
      0
    );
    addEditStockItemForm.setFieldValue("totalDuty", total);
  };

  const onFill = (initialValues) => {
    addEditStockItemForm.setFieldsValue({
      id: initialValues?.id,
      stockTypeCode: initialValues?.stockTypeCode,
      stockTypeName: initialValues?.stockTypeName,
      stockType: { id: initialValues?.stockTypeId },
      itemNumber: initialValues?.itemNumber,
      packingType: {
        name: initialValues?.receivedPackingTypeName,
        id: initialValues?.receivedPackingTypeId,
      },
      receivedQuantity: initialValues?.tiepPackageQuantity,
      quantityPerItem: initialValues?.tiepQuantityPerPackage,

      receivedUomName: initialValues?.receivedUomName,
      receivedUomId: initialValues?.receivedUomId,

      netWeight: initialValues?.netWeight,
      grossWeight: initialValues?.grossWeight,
      totalDuty: initialValues?.totalLiabilityAmount,
      vat: initialValues?.totalVatAmount,
    });

    initialValues?.stockReceiptLineTaxes?.forEach((item) => {
      addEditStockItemForm.setFieldValue(
        ["stockReceiptLineTaxes", item.taxType.id, "taxAmount"],
        item.taxAmount ?? 0
      );

      addEditStockItemForm.setFieldValue(
        ["stockReceiptLineTaxes", item.taxType.id, "id"],
        item.id ?? null
      );
    });
  };

  const handleMaterialSelect = (selected, option) => {
    const selectedMaterial = getMaterialSelected(option.key);
    addEditStockItemForm.setFieldsValue({
      stockTypeCode: selectedMaterial?.code,
      stockType: {
        id: option.key,
      },
      packingType: {
        id: selectedMaterial?.packingType?.id,
        name: selectedMaterial?.packingType?.name,
      },
      receivedUomName: selectedMaterial.uom?.name ?? "",
      receivedUomId: selectedMaterial.uom?.id ?? "",
    });
  };

  return (
    <Drawer
      title={title}
      width={560}
      onClose={() => {
        addEditStockItemForm.resetFields();
        onDrawerClose();
      }}
      open={isDrawerOpen}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        name="addEdit-stock"
        layout="vertical"
        requiredMark={false}
        form={addEditStockItemForm}
        onValuesChange={handleValuesChange}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name={["stockTypeCode"]} label="HS Code">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={"id"} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["stockTypeName"]}
              label="Material*"
              rules={[
                {
                  required: true,
                  message: "Please select a Material!",
                },
              ]}
            >
              {/* <AutoComplete
                options={filteredOptions}
                style={{ width: 200 }}
                onSelect={handleMaterialSelect}
                onSearch={handleSearch}
                placeholder="input here"
              /> */}

              <Select onChange={handleMaterialSelect}>
                {materialTypes?.map((item) => (
                  <Select.Option value={item.name} key={item.id}>
                    {item.name} ({item.secondaryCode})
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            {/* <Form.Item name={"materialId"} hidden> */}
            <Form.Item name={["stockType", "id"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["itemNumber"]} label="Item Number">
              <Input type="number" placeholder="Item Number" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["packingType", "name"]} label="Packing Type*">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["packingType", "id"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={"receivedQuantity"}
              label="Number of Units*"
              rules={[
                {
                  required: true,
                  message: "Please enter Number of Units!",
                },
              ]}
            >
              <Input type="number" placeholder="Number of Units" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["receivedUomName"]} label="UOM">
              {/* <Input disabled /> */}

              {/* <Select
                onChange={(selected, option) => {
                  addEditStockItemForm.setFieldValue(
                    ["receivedUomId"],
                    option.key
                  );
                }}
              >
                {measurementTypes?.map((item) => (
                  <Select.Option key={item.id} value={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select> */}
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["receivedUomId"]} hidden>
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={"quantityPerItem"} label="Quantity Per Unit">
              <Input type="number" placeholder="Quantity Per Unit" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["netWeight"]} label="Net Weight">
              <Input type="number" placeholder="Net Weight" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name={["grossWeight"]} label="Gross Weight">
              <Input type="number" placeholder="Gross Weight" />
            </Form.Item>
          </Col>

          {taxTypes &&
            taxTypes.map((item, index) => (
              <Row gutter={16} key={item.id}>
                <Col span={24}>
                  <Form.Item
                    //name={["stockReceiptLineTaxes", index, "taxType", "id"]}
                    name={["stockReceiptLineTaxes", item.id, "id"]}
                    hidden
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    //name={["stockReceiptLineTaxes", index, "taxType", "id"]}
                    name={["stockReceiptLineTaxes", item.id, "taxType", "id"]}
                    hidden
                    initialValue={item.id}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["stockReceiptLineTaxes", item.id, "taxType", "code"]}
                    initialValue={item.code}
                    hidden
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name={["stockReceiptLineTaxes", item.id, "taxAmount"]}
                    label={`Tax Line ${index + 1}`}
                  >
                    <Input
                      addonBefore={`${item.code}`}
                      addonAfter="LKR"
                      onchange={() => {}}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}

          <Col span={24}>
            <Form.Item name={["totalDuty"]} label="Total Duty">
              <Input type="number" readOnly />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name={["vat"]}
              label="VAT*"
              rules={[
                {
                  required: true,
                  message: "Please enter VAT!",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                max={9999999999}
                defaultValue={0}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          width: "100%",
          borderTop: "1px solid #e9e9e9",
          padding: "10px 16px",
          background: "#fff",
          textAlign: "right",
        }}
      >
        <Button onClick={onDrawerClose} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button
          onClick={(value) => {
            addEditStockItemForm
              .validateFields()
              .then((values) => {
                addEditStockItemForm.resetFields();
                initialValues = {};
                finishSubmit(values);
              })
              .catch((error) => console.log(error));
          }}
          type="primary"
          loading={isloading}
        >
          Submit
        </Button>
      </div>
    </Drawer>
  );
}

export default AddMaterialDrawer;
